import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { NgxPermissionsGuard } from 'ngx-permissions';
import { AgmCoreModule } from '@agm/core';
import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';
import { NgxCarouselModule } from 'ngx-carousel';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { SharedModule } from '../../../../../../core/modules/shared.module';
import { FuseWidgetModule } from '../../../../../../core/components/widget/widget.module';
import { CourseYearService } from '../../../../../services/cour-years/course-year.service';
import { EditProfessionalConceptComponent } from './edit-professional-concept.component';
import { ConceptService } from '../../../../../services/concepts/concept.service';
import { ProfessionalConceptService } from '../../../../../services/professional-concept/professional-concept.service';

const routes = [
    {
        path: 'pages/management/professionalconcept/view/:id',
        component: EditProfessionalConceptComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_HOME',
                redirectTo: '/pages/errors/error-403'
            },
            mode : 'view'
        }
    },
    {
        path: 'pages/management/professionalconcept/edit/:id',
        component: EditProfessionalConceptComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_HOME',
                redirectTo: '/pages/errors/error-403'
            },
            mode : 'edit'
        }
    }
];

@NgModule({
    declarations: [
        EditProfessionalConceptComponent
    ],
    imports: [
        SharedModule,
        RouterModule.forChild(routes),
        AgmCoreModule,
        AgmSnazzyInfoWindowModule,
        NgxCarouselModule,
        FuseWidgetModule,
        NgxChartsModule
    ],
    exports: [
        EditProfessionalConceptComponent
    ],
    providers: [
        CourseYearService,
        ConceptService,
        ProfessionalConceptService
    ],
    entryComponents: [

    ]
})

export class EditProfessionalConceptModule {
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/professional-concept/edit-professional-concept/edit-professional-concept.module.ts